import * as React from "react";
const SvgFiRrPawHeart = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M14.998 14.883c0 .51-.202 1.117-1.166 1.117a3.2 3.2 0 0 1-.8-.139 3.46 3.46 0 0 0-2.068 0c-1.099.363-2.007.006-1.966-.978C9 13.428 10.485 12 11.998 12s2.998 1.428 2.998 2.883zm.573-4.863c-.514-.061-.98.425-1.06 1.304-.163 2.075 1.623 2.346 1.862.222.08-.878-.288-1.464-.802-1.526m-7.258 0c-.514.061-.882.647-.802 1.526.239 2.124 2.024 1.852 1.862-.222-.081-.879-.546-1.365-1.06-1.304m3.29-.711c-.082-.879-.546-1.365-1.061-1.304-.516.061-.881.647-.8 1.526.239 2.125 2.025 1.852 1.861-.222m2.645.222c.08-.878-.288-1.464-.802-1.526-.514-.061-.98.425-1.06 1.304-.163 2.076 1.623 2.346 1.862.222M24 7.789c0 4.885-5.546 11.17-9.273 14.203a4.47 4.47 0 0 1-2.827 1.001 4.46 4.46 0 0 1-2.839-1.013C5.558 19.099 0 12.699 0 7.79 0 4.046 3.033 1 6.762 1 8.81 1 10.71 1.91 12 3.503A6.7 6.7 0 0 1 17.238 1C20.967 1 24 4.045 24 7.789m-2 0c0-2.641-2.136-4.79-4.762-4.79a4.72 4.72 0 0 0-3.757 1.854c-.715.928-2.247.928-2.963 0A4.72 4.72 0 0 0 6.762 3C4.137 3 2 5.148 2 7.79c0 3.996 4.872 9.801 8.331 12.646a2.45 2.45 0 0 0 3.134.005C17.603 17.075 22 11.496 22 7.789"
    />
  </svg>
);
export default SvgFiRrPawHeart;
